import { SaleSliceState } from 'src/core/models'

const salesState: SaleSliceState = {
  list: {
    loading: false,
    error: null,
    filterText: '',
    sales: [],
    filtered: [],
    selected: []
  },
  getOne: {
    loading: false,
    error: null,
    sale: null
  },
  sendDocument: {
    loading: false,
    success: false,
    error: null
  },
  deleteDocument: {
    loading: false,
    success: false,
    error: null
  }
}

export { salesState as initialState }
